import styled from "styled-components";
import { Container } from "../components/common/CommonComponents.jsx";
import { useNavigate } from "react-router-dom";

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const Button = styled.button`
  flex: 1;
  white-space: nowrap; /* 줄바꿈 방지 */
  padding: 0.75rem 0;
  background-color: #22365c;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: clamp(18px, 2vw, 24px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  width: 100%;
  &:hover {
    background-color: #1c2c4f;
  }
`;

const Button_2 = styled.button`
  flex: 1;
  white-space: nowrap; /* 줄바꿈 방지 */
  background-color: #d46c5c;
  padding: 0.75rem 0;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: clamp(18px, 2vw, 24px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  width: 100%;
  &:hover {
    background-color: #bf5f51;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  max-width: 1200px; /* 원하는 최대 너비 */
  margin: 0 auto; /* 가운데 정렬 */
  gap: 1rem; /* 버튼 사이 간격 */
  width: 100%;
`;

const ContentContainer = styled(Container)`
  max-width: 1200px;
  margin-top: 4rem;
`;

const LandingPage = () => {
  const nav = useNavigate();

  const link =
    "https://forms.office.com/pages/responsepage.aspx?id=m6t3qSHXsE6ZRohL0RfXydjcF9Nz1lBMilGmzIh_MYVUMkwzVEVEUkxIRDRQVkNSVjNIV0xSME1QOS4u&route=shorturl";

  const link_2 = `https://wtplaw.co.kr/kr/app`;
  return (
    <ContentContainer>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ImageWrapper>
          <Image src="/images/event/landing.png" alt="game" />
          <ButtonWrapper>
            <Button onClick={() => window.open(link, "_blank")}>
              상담신청 하기
            </Button>
            <Button_2 onClick={() => window.open(link_2, "_blank")}>
              집단조정 참여하기
            </Button_2>
          </ButtonWrapper>
        </ImageWrapper>
      </div>
    </ContentContainer>
  );
};

export default LandingPage;
